// src/menu/extraSections/ExtraSectionCreate.js

import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
  useGetIdentity,
} from "react-admin";

const ExtraSectionCreate = () => {
  const { identity } = useGetIdentity();

  return (
    <Create>
      <SimpleForm>

        {/* 🔴 ZORUNLU: KURUM ID (BACKEND İSTİYOR) */}
        <TextInput
          source="kurum_id"
          defaultValue={identity?.kurum_id}
          style={{ display: "none" }}
        />

        {/* 🔴 ZORUNLU: CATEGORY KEY (DB NOT NULL) */}
        <TextInput
          source="category_key"
          label="Kategori Anahtarı (category_key)"
          validate={required()}
          fullWidth
          helperText="Örn: main_dishes, desserts, drinks"
        />

        {/* 🔤 BAŞLIKLAR (DİL BAZLI) */}
        <TextInput
          source="title_tr"
          label="Başlık (TR)"
          validate={required()}
          fullWidth
        />

        <TextInput
          source="title_en"
          label="Title (EN)"
          fullWidth
        />

        <TextInput
          source="title_de"
          label="Titel (DE)"
          fullWidth
        />

        {/* 🧩 ICON (OPSİYONEL) */}
        <TextInput
          source="icon"
          label="Icon (opsiyonel)"
          fullWidth
        />

        {/* ✅ AKTİF */}
        <BooleanInput
          source="aktif"
          label="Aktif"
          defaultValue={true}
        />

        {/* 🔢 SIRA */}
        <NumberInput
          source="sira"
          label="Sıra"
          defaultValue={0}
        />

      </SimpleForm>
    </Create>
  );
};

export default ExtraSectionCreate;
